import { RuntimeEnum } from "@/enums";
import type { Environment, Runtime, UnknownRecord } from "@/types";
import { getEnvOrThrow } from "@/utils/env";

export const IS_SERVER = typeof document === "undefined";

export const SITE_URL: string = getEnvOrThrow(
  process.env.NEXT_PUBLIC_SITE_URL,
  "NEXT_PUBLIC_SITE_URL",
);

// Optional second origin used while accessing the dev server from another device on the LAN
// (e.g. testing a mobile browser). Only relevant in development.
export const SITE_URL_NETWORK: string | undefined =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_SITE_URL_NETWORK
    : undefined;

export const ENV: Environment = getEnvOrThrow(
  process.env.NEXT_PUBLIC_ENV,
  "NEXT_PUBLIC_ENV",
) as Environment;

export const RUNTIME: Runtime = (
  typeof document === "undefined"
    ? typeof (globalThis as UnknownRecord).EdgeRuntime === "string"
      ? RuntimeEnum.EDGE
      : RuntimeEnum.SERVER
    : RuntimeEnum.CLIENT
) as Runtime;

export const REQUEST_ID_HEADER = "x-request-id" as const;
export const REQUEST_ID_COOKIE = REQUEST_ID_HEADER;
export const REQUEST_ID_META = "request-id" as const;
